<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Instituciones</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-container fluid>
                  <v-row>
                      <v-col cols="4" v-for="(inst) in datos" :key="inst.id">
                          <v-card elevation="10">
                          <v-card-title>
                            
                            <v-avatar size="100">
                              <v-img :src="inst.imagen" alt="Institucion">
                              </v-img>
                            </v-avatar>
                            <!-- <v-avatar size="100" @click="editLogo(inst)">
                              <v-img :src="inst.imagen" alt="Institucion">
                                <v-icon>mdi-pencil</v-icon>
                              </v-img>
                            </v-avatar>                             -->
                            <p>{{inst.nombre}}</p>
                          </v-card-title>
                            <span class="d-flex justify-center">
                              {{inst.direccion}}
                            </span>
                          <v-card-text>
                          </v-card-text>
                            <v-card-actions>
                              <v-icon small class="mr-2" @click="editItem(inst)">mdi-pencil</v-icon>
                              <v-spacer></v-spacer>
                              <v-icon small @click="deleteItem(inst)">mdi-delete</v-icon>
                            </v-card-actions>
                          </v-card>
                      </v-col>
                  </v-row>
          </v-container>

        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
        
      <image-input v-model="avatar">
        <div slot="activator">  
          <v-avatar size="100" v-if="editedItem.imagen">
            <v-img :src="editedItem.imagen" alt="Institucion"> </v-img>
          </v-avatar>
          <v-avatar size="100" v-else class="grey lighten-3 mb-3">
            <span>Agregar Logo</span>
          </v-avatar>
        </div>
      </image-input>
        </v-card-subtitle>        
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="editedItem.nombre" label="Nombre" required outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="editedItem.direccion" label="Correo Principal" required outlined></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogImg" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Actualizar logo de {{editedItem.nombre}}</span>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
          <v-avatar  size="100">
            <v-img :src="editedItem.imagen" alt="Institucion">
            </v-img>
          </v-avatar>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  accept="image/*"
                  label="Ingrese el nuevo logo"
                  outlined
                  v-model="chosenFile"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="clogo">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
import api from "../conf/ruta-base";
import store from "../store";
import ImageInput from '../components/ImageInput';
export default {
  name: "instituciones",
  components:{ImageInput},
  data: () => ({
    apiPath: "institucion",
    search: "",
    dialog: false,
    dialogImg: false,
    chosenFile: null,
    avatar: null,
    saving: false,
    saved: false,
    headers: [
      { text: "Id", value: "id" },
      {
        text: "Institucion",
        align: "start",
        sortable: true,
        value: "nombre"
      },
      { text: "Imagen", value: "imagen" },
      { text: "Correo", value: "correo" },
      { text: "Direccion", value: "direccion" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    datos: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      nombre: "",
      imagen: "",
      correo: "",
      direccion: ""
    },
    defaultItem: {
      id: "",
      nombre: "",
      imagen: '',
      correo: "",
      direccion: ""
    }
  }),
  mounted() {
    axios
      .get(api.api + this.apiPath)
      .then(r => {
        let i = 0;
        for (i = 0; i < r.data.length; i++) {
          r.data[i].imagen = api.api+'uploads/'+r.data[i].imagen
          this.datos.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  watch: {
    avatar(){
      console.log(this.avatar)
      this.editedItem.imagen = this.avatar.imageURL
      this.chosenFile = this.avatar.imageFile
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Institución" : "Modificar";
    }
  },
  methods: {

    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.dialogImg = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave(){
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.nombre.length == 0){
          bandera = false
          err = 'Debe ingresar un nombre a la Institución.'
        }

        if(bandera && (this.editedItem.direccion.length == 0)){
          bandera = false
          err = 'Debe indicar un correo a la Institución'
        }
  
      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.datos[this.editedIndex], this.editedItem);
        let img = new FormData()
        let opt = {
          headers: {
            'Accept': 'application/json','Content-Type': 'multipart/form-data',
          }
        }
        if(this.chosenFile !== null)
          img.append('imagen',this.chosenFile,this.chosenFile.name)
        img.append('id',this.editedItem.id)
        img.append('nombre',this.editedItem.nombre)
        img.append('direccion',this.editedItem.direccion)
        axios
          .put(api.api + this.apiPath, img, opt)
          .then(res => {
            this.chosenFile = null
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        let img = new FormData()
        let opt = {
          headers: {
            'Accept': 'application/json','Content-Type': 'multipart/form-data',
          }
        }
        if(this.chosenFile !== null)
          img.append('imagen',this.chosenFile,this.chosenFile.name)
        img.append('nombre',this.editedItem.nombre)
        img.append('direccion',this.editedItem.direccion)
        axios
          .post(api.api + this.apiPath, img, opt)
          .then(res => {
            this.chosenFile = null
            res.data.imagen = api.api+'uploads/'+res.data.imagen
            this.datos.push(res.data);
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem (item) {
      const index = this.datos.indexOf(item)
      console.log(item.id)
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {
        if(ok){
          axios.delete(api.api + this.apiPath, {data: item})
          .then(res => {
            if(res.data.c=='success'){
              this.datos.splice(index, 1)
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },
    
    editLogo(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogImg = true;
    },
    
    clogo(){
      let img = new FormData()
      let opt = {
        headers: {
          'Accept': 'application/json','Content-Type': 'multipart/form-data',
        }
      }
      img.append('imagen',this.chosenFile,this.chosenFile.name)
      img.append('id',this.editedItem.id)
      axios.post(api.api + this.apiPath + '/logo',img,opt)
      .then(r => {
        this.toast(r.data.c, r.data.mensaje)
        this.editedItem.imagen = api.api+'uploads/'+r.data.imagen
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        this.dialogImg = false
      })
      .catch(err => {
        console.log(err)
      })
    },
  }
};
</script>